import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "./index";

export const AI_missedPunchToday = apiBase.createInstance({
  endpoint: "/missed-punch-alert/today",
  method: "get",
  reducer: "userReducer",
  reduxKey: "missedPunchToday",
  action: "GET_MISSED_PUNCH_TODAY",
  onSuccess: (data) => data,
});

export const AI_missedPunchHistory = apiBase.createInstance({
  endpoint: "/missed-punch-alert/history",
  method: "get",
  reducer: "userReducer",
  reduxKey: "missedPunchHistory",
  action: "GET_MISSED_PUNCH_HISTORY",
  onSuccess: (data) => data.history,
});

export const AI_missedPunchAddLeave = apiBase.createInstance({
  endpoint: "/missed-punch-alert/add-leave",
  method: "post",
  reducer: "userReducer",
  reduxKey: "missedPunchAddLeave",
  action: "ADD_MISSED_PUNCH_LEAVE",
  middleware: notificationMiddleWare,
  onSuccess: (data) => data,
});
